// components/ModalCommon/ModalCommon.tsx
import React from 'react';
import { Modal } from 'antd';
import { ButtonCommon } from '../Button/ButtonCommon';

interface ModalCommonProps {
  open: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  confirmDisabled?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  width?: number;
  children: React.ReactNode;
  header?: React.ReactNode;
  showClose?: boolean;
  hideFooter?: boolean;
}

const ModalCommon: React.FC<ModalCommonProps> = ({
  open,
  onClose,
  onConfirm,
  confirmDisabled = false,
  confirmLabel = 'Xác nhận',
  cancelLabel = 'Trở lại',
  showClose = false,
  width = 682,
  children,
  header,
  hideFooter,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      closable={showClose}
      className='bg-[var(--bgGreyColor)] rounded'
      width={width}
      footer={
        hideFooter ? null : (
          <div className='flex justify-center gap-6 mt-0 mb-3'>
            <ButtonCommon
              color='barcode'
              className='text-black'
              radius='rounded'
              disabled={confirmDisabled}
              isDisabled={confirmDisabled}
              size='xs'
              onClick={onClose}
            >
              {cancelLabel}
            </ButtonCommon>
            {onConfirm && (
              <ButtonCommon
                color='basic'
                disabled={confirmDisabled}
                isDisabled={confirmDisabled}
                className='bg-[var(--primaryColor500)] px-3 gap-2'
                radius='rounded'
                onClick={onConfirm}
              >
                {confirmLabel}
              </ButtonCommon>
            )}
          </div>
        )
      }
      centered
    >
      {header && <div className=''>{header}</div>}
      {children}
    </Modal>
  );
};

export default ModalCommon;
